const firebaseConfig = {
    apiKey: "AIzaSyBNM8e6lTJW_LLAqpSv0lZE6FZYJLjLYe4",
    authDomain: "alphamarktravel.firebaseapp.com",
    projectId: "alphamarktravel",
    storageBucket: "alphamarktravel.appspot.com",
    messagingSenderId: "163210633306",
    appId: "1:163210633306:web:7a698fe561a42ab99af863"
};

export default firebaseConfig;


// console.log(process.env)
// const firebaseConfig = {
//     apiKey: process.env.REACT_APP_API_KEY,
//     authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//     projectId: process.env.REACT_APP_PROJECT_ID,
//     storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//     messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
//     appId: process.env.REACT_APP_APP_ID,
// };

// export default firebaseConfig;